<!-- MMLIcon.vue -->
<script setup lang="ts">
    import '../../../../css/choice.css'
    import { computed } from 'vue';
    import { MMLConnectionType } from '../../../Enums/ChoiceEnums';
    import { DisplayStyle, IconTypes } from '../../../Enums/UiEnums';

    import { mmlConnectionDesc } from './MML';
    import Icon from '../../../components/Icon.vue';

    const props = defineProps<{
        connectionType?: MMLConnectionType,
        class?: string
    }>();

    const emit = defineEmits(["click"]);

    const mmlIconType = computed<IconTypes|undefined>(() =>{
        switch(props.connectionType)
        {
            case MMLConnectionType.Connected: 
                return IconTypes.MMLConnected;
            
            case MMLConnectionType.OptOut: 
                return IconTypes.MMLOptOut;
        }
        return IconTypes.MMLInvite;
    });

    const mmlIconDisplayStyle = computed<DisplayStyle|undefined>(() =>{
        switch(props.connectionType)
        {
            case MMLConnectionType.Connected: 
                return DisplayStyle.Success;
            
            case MMLConnectionType.OptOut: 
                return DisplayStyle.Danger;
        }
        return DisplayStyle.Primary;
    });

    const mmlIconTitle = computed(()=>{
        return mmlConnectionDesc(props.connectionType);
    });

</script>

<template>
    <Icon :icon="mmlIconType" 
          :displayStyle="mmlIconDisplayStyle" 
          :title="mmlIconTitle"
          :class="$props.class"
          @click="() => emit('click')"/>
</template>